import { createContext, useEffect } from 'react'
import { ReactNode, useState } from 'react'
import { Socket } from 'socket.io-client'
import { initWebSocket, registerConnectionChangedListener } from '../@core/lib/wsClient'

type WebSocketContextType = {
  socket: Socket | null
  isConnected: boolean
}
const defaultProvider: WebSocketContextType = {
  socket: null,
  isConnected: false
}

const WebSocketContext = createContext<WebSocketContextType>(defaultProvider)

const WebSocketProvider = ({ children }: { children: ReactNode }) => {
  const [isConnected, setIsConnected] = useState(false)
  const [socket, setSocket] = useState<Socket | null>(null)

  useEffect(() => {
    const init = async () => {
      registerConnectionChangedListener((isConnected: boolean) => {
        setIsConnected(isConnected)
      })

      const socket: Socket | null = await initWebSocket()
      if (socket) {
        setSocket(socket)

        // Check if socket is already connected
        if (socket.connected) {
          setIsConnected(true)
        }
      }
    }
    init()
  }, [])

  return (
    <WebSocketContext.Provider
      value={{
        socket,
        isConnected
      }}
    >
      {children}
    </WebSocketContext.Provider>
  )
}

export { WebSocketContext, WebSocketProvider }
